import { useContext } from "react";
import { Contexts } from "./contexts";

export const useLoading = () => {
    const { isLoading, setIsLoading } = useContext(Contexts);
    return [isLoading, setIsLoading];
};

export const useDeals = () => {
    const { deals, setDeals } = useContext(Contexts);
    return [deals, setDeals];
};

export const useStores = () => {
    const { stores, setStores } = useContext(Contexts);
    return [stores, setStores];
}

export const useSearch = () => {
    const { searchString, setSearchString } = useContext(Contexts);
    return [searchString, setSearchString];
};

export const usePage = () => {
    const { page, setPage } = useContext(Contexts);
    return [page, setPage];
};

export const useFavoriteOpen = () => {
    const { favoriteOpen, setFavoriteOpen } = useContext(Contexts);
    return [favoriteOpen, setFavoriteOpen];
};

export const useFavorite = () => {
    const { favorites, setFavorites } = useContext(Contexts);
    return [favorites, setFavorites];
};

export const useLanguage = () => {
    const { userLanguage, setUserLanguage } = useContext(Contexts);
    return [userLanguage, setUserLanguage];
};

export const useDialog = () => {
    const { dialog, setDialog } = useContext(Contexts);
    return [dialog, setDialog];
};

export const useCategory = () => {
    const { category, setCategory } = useContext(Contexts);
    return [category, setCategory];
};

export const useDstore = () => {
    const { dstore, setDstore } = useContext(Contexts);
    return [dstore, setDstore];
};

export const useCookie = () => {
    const { cookie, setCookie } = useContext(Contexts);
    return [cookie, setCookie];
};

